import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "icon" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Symbols",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Top",
				transform: "translate(-24.000000, -24.000000)",
				fill: "#FFFFFF",
				children: /* @__PURE__ */ _jsx("g", {
					transform: "translate(24.000000, 24.000000)",
					id: "icon",
					children: /* @__PURE__ */ _jsx("path", { d: "M5.9823988,2.11720998e-16 L18.0176012,2.41696072e-16 C20.0978116,-1.40432378e-16 20.8521461,0.216593093 21.61264,0.623309642 C22.3731338,1.03002619 22.9699738,1.6268662 23.3766904,2.38736003 C23.7834069,3.14785385 24,3.90218841 24,5.9823988 L24,18.0176012 C24,20.0978116 23.7834069,20.8521461 23.3766904,21.61264 C22.9699738,22.3731338 22.3731338,22.9699738 21.61264,23.3766904 C20.8521461,23.7834069 20.0978116,24 18.0176012,24 L5.9823988,24 C3.90218841,24 3.14785385,23.7834069 2.38736003,23.3766904 C1.6268662,22.9699738 1.03002619,22.3731338 0.623309642,21.61264 C0.216593093,20.8521461 -1.6982679e-16,20.0978116 2.92286355e-16,18.0176012 L1.61130715e-16,5.9823988 C-9.36215854e-17,3.90218841 0.216593093,3.14785385 0.623309642,2.38736003 C1.03002619,1.6268662 1.6268662,1.03002619 2.38736003,0.623309642 C3.14785385,0.216593093 3.90218841,-1.23015997e-16 5.9823988,2.11720998e-16 Z M11.2822489,13.9030998 L10.4017821,19.2925118 C10.2882993,19.9871496 11.1889524,20.3608044 11.6005319,19.7898382 L17.8741388,11.0867385 C18.1919954,10.64579 17.8769033,10.0302335 17.3333333,10.0302335 L12.8510845,10.0302335 L13.7315513,4.64082152 C13.845034,3.94618377 12.9443809,3.57252897 12.5328014,4.14349509 L6.2591945,12.8465949 C5.94133795,13.2875433 6.25643002,13.9030998 6.8,13.9030998 L11.2822489,13.9030998 Z M8.10238433,12.5697665 L11.9593091,7.21922389 L11.4087223,10.589412 C11.3424408,10.995127 11.6555731,11.3635669 12.0666667,11.3635669 L16.030949,11.3635669 L12.1740243,16.7141094 L12.724611,13.3439213 C12.7908925,12.9382063 12.4777602,12.5697665 12.0666667,12.5697665 L8.10238433,12.5697665 Z" })
				})
			})
		})
	]
});
export default SvgIcon;
